/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetOrdersQueryParams, GetOrders200, GetOrders400, GetOrdersQueryResponse } from '../entities/GetOrders'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { getOrdersResponseSchema } from './getOrdersResponseSchema'
import { z } from 'zod'

export const getOrdersQueryParamsSchema = z.object({
  drivee_city_id: z.number().int().optional(),
  from_address: z.string().optional(),
  from_date: z.string().optional(),
  limit: z.number().int().min(1).max(100).default(10),
  offset: z.number().int().min(0).default(0),
  payment_method: z.array(z.enum(['cash', 'card'])).optional(),
  phone: z.string().optional(),
  status: z.array(z.enum(['process', 'done', 'cancel'])).optional(),
  to_address: z.string().optional(),
  to_date: z.string().optional(),
}) as unknown as ToZod<GetOrdersQueryParams>

/**
 * @description OK
 */
export const getOrders200Schema = z.lazy(() => getOrdersResponseSchema) as unknown as ToZod<GetOrders200>

/**
 * @description Bad Request
 */
export const getOrders400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetOrders400>

export const getOrdersQueryResponseSchema = z.lazy(() => getOrders200Schema) as unknown as ToZod<GetOrdersQueryResponse>